<template>
  <ul class="kt-menu__nav">
    <template v-for="(menu, i) in menuItems">
      <KTMenuItem v-if="!menu.section" :menu="menu" :key="i"></KTMenuItem>
      <KTMenuSection v-if="menu.section" :menu="menu" :key="i"></KTMenuSection>
    </template>
  </ul>
</template>

<script>
import KTMenuItem from "@/views/theme/aside/MenuItem.vue";
import KTMenuSection from "@/views/theme/aside/MenuSection.vue";
import menuConfig from "@/common/config/menu.config.json";
import {FCM} from '@/utils/firebase-fcm'
import {GetRole} from '@/utils/auth';
export default {
  created(){
        FCM.fcmInit();
  },
  name: "KTAsideMenu",
  components: {
    KTMenuItem,
    KTMenuSection
  },
  computed: {
    menuItems () {
      var role = GetRole()

      
      return menuConfig.aside.items.filter(e=>{
        return e.role.includes(role)
      });
    }
  }
};
</script>
